var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join"},[_c('subtitle',[_c('div',{attrs:{"slot":"above-title"},slot:"above-title"},[_vm._v("加盟流程")])]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1100px","margin":"0 auto"}},[_c('img',{staticClass:"content_img",attrs:{"src":require("assets/img/home/join-step.png"),"width":"100%","alt":""}})])
}]

export { render, staticRenderFns }